import { TISCH_KONFIGURATOR_APP_CODE } from '../../constants';

const getMessageForScopeAndKey = (scope: string, key: string): string => {
  const messages: Record<string, string> = {
    pdfResultHeader: 'Gratulation! Sie haben die Konfiguration abgeschlossen',
  };

  if (scope === TISCH_KONFIGURATOR_APP_CODE) {
    messages.pdfResultHeader =
      'Gratulation! Sie haben Ihren Tisch fertig konfiguriert.';
  }

  return messages[key];
};

const getMessage = (
  key: string,
  scope: string,
  replacements?: Record<string, string>
): string => {
  const rawMessage = getMessageForScopeAndKey(scope, key);

  if (!rawMessage) {
    console.warn(`Missing message for key "${key}" in scope "${scope}"`);
    return 'Unbekannte Nachricht';
  }

  if (!replacements) {
    return rawMessage;
  }

  return Object.entries(replacements).reduce((msg, [placeholder, value]) => {
    return msg.replaceAll(`{${placeholder}}`, value);
  }, rawMessage);
};

export { getMessage };
